/**
 * Shared interval handle for the open-balances list view polling. Cleared when body is found or on timeout.
 */
let openBalancesPageLoadInterval = null
let openBalancesListViewClickHandler = null

/**
 * Page inject for the open balances (Offene Posten) flow in Impower.
 * new/overview: fetch interception in lib/luxFetchHandlers/openBalances.js
 * list/view: redirect on "Vorschau & Versenden" click.
 */
const onOpenBalancesPageMatch = () => {
  const path = window.location.pathname
  const isListView = /\/order-open-balances\/list\/view\/\d+$/.test(path)

  if (!isListView) return

  if (openBalancesPageLoadInterval) {
    clearInterval(openBalancesPageLoadInterval)
  }

  const maxAttempts = 100 // 10 seconds (100 * 100ms)
  let attempts = 0

  openBalancesPageLoadInterval = setInterval(() => {
    attempts++
    const pageContent = document.querySelector('body')

    if (!pageContent) {
      if (attempts >= maxAttempts) {
        clearInterval(openBalancesPageLoadInterval)
        openBalancesPageLoadInterval = null
        console.error('body not found after timeout')
      }
      return
    }

    clearInterval(openBalancesPageLoadInterval)
    openBalancesPageLoadInterval = null

    if (openBalancesListViewClickHandler) {
      document.removeEventListener('click', openBalancesListViewClickHandler, true)
    }

    openBalancesListViewClickHandler = (e) => {
      const button = e.target.closest('.ant-btn-primary')
      if (!button) return

      const buttonText = button.textContent?.trim()
      if (buttonText !== 'Vorschau & Versenden') return

      e.stopImmediatePropagation()

      const pathParts = window.location.pathname.split('/').filter((part) => part)
      const id = pathParts[pathParts.length - 1]

      window.location.href = `/nachrichtenversand?type=dunning&sourceIds=${id}`
    }

    document.addEventListener('click', openBalancesListViewClickHandler, true)
  }, 100)
}
